/**
 * Which fulfillment methods a venue offers, read off the untyped `clientData` blob.
 *
 * The backend names the in-store-pickup flag differently per endpoint:
 *   - `api/v3/shop/get-for-app/{id}` -> `has_in_store_pickup_delivery`
 *   - `api/v3/shop/order-info`       -> `has_in_store_delivery`
 * `sessionStorage.clientData` is built from get-for-app (SplashComponent), so today it only ever
 * carries the first spelling — ShopStatusService merges order-info's status fields but not its
 * delivery flags. Reading only `has_in_store_delivery` therefore made every pickup-enabled venue
 * look delivery-only, hiding the delivery/pickup toggle in the order form. Both names are accepted
 * here so this keeps working if order-info's flags are ever merged in too; iOS does the same in
 * OrderingEligibility.swift.
 *
 * `has_home_delivery` is spelled the same on both endpoints.
 */
export function hasHomeDelivery(clientData: any): boolean {
  return clientData?.has_home_delivery === true;
}

export function hasInStorePickup(clientData: any): boolean {
  return clientData?.has_in_store_pickup_delivery === true ||
         clientData?.has_in_store_delivery === true;
}

/**
 * What a guest at a TABLE can pay with.
 *
 * Dine-in has its own list now. It used to read `pickup_in_store_payment_methods`, and
 * those rows are only written when the venue has in-store pickup switched on — so a
 * venue that only does dine-in offered no payment methods at all, with nothing on
 * screen or in the logs to say why.
 *
 * ⚠️ The fallback is DEPLOY-ORDER INSURANCE, not a feature. A backend that predates
 * `dine_in_payment_methods` keeps behaving exactly as it did. Drop it once every
 * environment serves the new field — leaving it in forever quietly restores the old
 * coupling for any venue whose dine-in list is legitimately empty.
 */
export function dineInPaymentMethods(clientData: any): string[] {
  const methods = clientData?.dine_in_payment_methods
    ?? clientData?.pickup_in_store_payment_methods;

  return Array.isArray(methods) ? methods : [];
}
